export default __webpack_public_path__ + "static/media/xmas_2024-cn.bb7d2bca.webp";